var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTagAsignado = function SvgTagAsignado(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "tag_asignado_svg__Capa_2",
    viewBox: "0 0 16 15.33"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "tag_asignado_svg__Capa_1-2",
    d: "m9 .62 1.87 3.78 4.17.61c.92.13 1.28 1.26.62 1.91l-3.02 2.94.71 4.16c.16.91-.8 1.61-1.62 1.18L8 13.24 4.27 15.2c-.82.43-1.78-.27-1.62-1.18l.71-4.16L.34 6.92c-.66-.65-.3-1.77.62-1.91l4.17-.61L7 .62c.41-.83 1.59-.83 2 0",
    fill: "#ffb967"
  })));
};
export default SvgTagAsignado;